var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExtract = function SvgExtract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.48 21.5",
    fill: "currentColor",
    width: "1em",
    height: "1em",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.21 10a1.72 1.72 0 1 1 0-3.43 3.27 3.27 0 0 0 0-6.54h-5A3.27 3.27 0 0 0 15 3.27a1.72 1.72 0 0 1-3.44 0A3.27 3.27 0 0 0 8.25 0 3.28 3.28 0 0 0 5 3.27 1.72 1.72 0 0 1 3.27 5a3.27 3.27 0 1 0 0 6.53 1.72 1.72 0 0 1 0 3.44 3.27 3.27 0 0 0 0 6.54h15a3.27 3.27 0 0 0 3.27-3.27 1.72 1.72 0 0 1 1.72-1.72 3.27 3.27 0 0 0 0-6.54ZM9.92 11.58a1.66 1.66 0 1 1 1.66-1.66 1.66 1.66 0 0 1-1.66 1.66Zm6.09-3a.78.78 0 0 1 .55-.23.78.78 0 0 1 0 1.55.78.78 0 0 1-.56-.27.79.79 0 0 1 0-1.09ZM14.9 17.4a2.5 2.5 0 1 1 2.49-2.5 2.5 2.5 0 0 1-2.49 2.5Z"
  })));
};
export default SvgExtract;